import _ from 'lodash'
import ResizeMixin from './ResizeMixin'

export default {
  name: 'KMain',
  mixins: [ResizeMixin],
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  render() {
    const style = _.assign({}, this.resizeStyle)

    const css = {
      'km-main': true,
    }

    const attrs = {}

    const props = {}

    const events = {}

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      props: props,
      on: events,
    }

    return (
      <main {...data}>
        {this.$slots.default}
      </main>
    )
  },
}
